import { ALL_REPORTS_PATH } from "../const";

export const NEW_REPORT_PAGE = "new";
export const NEW_REPORT_PATH = `${ALL_REPORTS_PATH}/${NEW_REPORT_PAGE}`;
